var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wk-desc-text"},[_c('tinymce',_vm._b({attrs:{"disabled":true,"toolbar":[],"init":{
      statusbar: false,
      placeholder: '描述文字内容',
      content_style: ' * {color: #262626; margin: 0;} body { font-size: 14px; }',
      quickbars_selection_toolbar: false,
      contextmenu: '',
      plugins: 'autoresize',
      autoresize_bottom_margin: 0
  }}},'tinymce',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }